class SizeChart extends HTMLElement {
  constructor() {
    super();
    const button = document.querySelector(".sizing-table button");
    const close = this.querySelector(".js-close");
    const sizeChart = this.querySelector(".size-chart");
    const chartToggle = document.querySelector(".sizing-table");
    if (chartToggle) {
      chartToggle.style.display = "block";
    }
    button.addEventListener("click", () => {
      sizeChart.classList.toggle("size-chart--active");
    });
    close.addEventListener("click", () => {
      sizeChart.classList.toggle("size-chart--active");
    });
  }
}
if (customElements.get("size-chart") === void 0) {
  customElements.define("size-chart", SizeChart);
}
